<template>
  <div class="IndexBox">
    <!-- <img :src=InitData.setting.user_bg_img class="login_cloud" /> -->
    <div class="ScrollBox UserInfo">
      <!-- <div style="margin:20px 0;">
        <span style="padding-left: 20px;font-size: 18px;">Hi，{{ $t('user.hello') }}</span>
        <router-link to="/user/info">
          <span style="padding-right: 20px;font-size: 18px; float: right;"><img :src="'./static/images/mine/tool@2x.png'" style="height: 24px;width: 24px;"/></span>
        </router-link>
      </div> -->

        <div class="user-header-bg" :style="{ backgroundImage: 'url(' + InitData.setting.user_bg_img + ')',backgroundSize:'100% 340px' }">
          <div  style="margin: 0 10px;">
            <van-cell class="info" :border="false" style="padding-top: 30px;padding-left: 10px;">
              <template #icon v-if="UserInfo.header && (UserInfo.header.indexOf('upload') >= 0 || UserInfo.header.indexOf('aliyuncs') >= 0)">
                <van-image class="head" :src="`${UserInfo.header}`" />
              </template>
              <template #icon v-else-if="UserInfo.header">
                <van-image class="head" :src="`./static/head/${UserInfo.header}`" />
              </template>
              <template #icon v-else>
                <van-image class="head" :src="'./static/head/head_1.png'" />
              </template>
              <template #title>
                <div class="username">
                  {{ UserInfo.username }}
                  <!-- <img :src="`./static/images/vip/${UserInfo.vip_level}.png`" style="width:30px;vertical-align: middle;"> -->
                  <span v-if="UserInfo.is_housekeeper == 1">
                    <img :src="`./static/icon/smart.png`" style="width:25px;vertical-align:middle;padding-bottom:10px;">
                  </span>
                </div>
                <div class="idcode-wrap">
                  ID: {{ UserInfo.idcode }}
                </div>
                
              </template>
              <van-col  style="margin-right: 20px;font-size: 18px;line-height: 25px;margin-top: 15px;">
                  <router-link to="/user/info"><img :src="'./static/images/mine/tool@2x.png'" style="height: 29px;width: 29px;vertical-align: middle;"/></router-link>
                </van-col>
            </van-cell>
          </div>
          <van-row>
            <van-col style="width:47%;padding:22px 18px 24px 0;text-align: center;">
              <div style="font-size: 24px;font-weight: 500;white-space: nowrap; color:#fff">{{ Number(UserInfo.balance) }}</div>
              <div style="font-size: 16px;font-weight: 500;white-space: nowrap; color:#fff">{{ $t("user.default[4]") }}({{ InitData.currency }})</div>
            </van-col>
            <van-col class="useridentity-col" offset="1">
              <div class="useridentity-text">{{ UserInfo.postName }}</div>
              <!-- <div class="useridentity-text">{{UserInfo.useridentity}}</div> -->
              <!-- <div class="useridentity-vipl">{{ $t("user.vipl") }}</div> -->
            </van-col>
          </van-row>
          <!-- <div style="background:url('./static/images/index-bg1@2x.png');background-size: 100% 130px;height: 130px;">
              <van-row>
                <van-col style="width:47%;padding:22px 18px 24px 0;text-align: center;" @click="toRecharge">
                  <div style="font-size: 14px;font-weight: 500;white-space: nowrap;">{{$t('wallet.default[1]')}}</div>
                  <img :src="`./static/images/icon-chongzhi@2x.png`" style="width:60px;height:60px">
                </van-col>
                <van-col style="width:47.5%;padding: 22px 18px 24px 75px;text-align: center;" offset="1" @click="toWithdraw">
                  <div style="font-size: 14px;font-weight: 500;height: 22px;padding-bottom: 20px;">{{$t('wallet.default[2]')}}</div>
                  <img :src="`./static/images/icon-tixian@2x.png`" style="width:60px;height:60px">
                </van-col>
              </van-row>
          </div> -->
        </div>

        <div style="background:url('./static/images/data-bg.png');position: absolute;background-size: 100% 225px;height: 210px;border-radius: 20px;background-color: #fff;margin-top: -110px;margin-left: 10px;margin-right: 10px;">
          <van-grid class="MyEarnings" :border="false" :column-num="2" style="margin:10px;border-radius:5px;background-color: rgba(255,255,255,0.1);">
            <van-grid-item>
              <template #icon>
                {{ $t("user.myEarnings.grid[2]") }}({{ InitData.currency }})
              </template>
              <template #text>
                <span style="color: var(--theme-color);">{{ UserInfo.today_earnings }}</span>
              </template>
            </van-grid-item>
            <van-grid-item>
              <template #icon>
              {{ $t("user.myEarnings.grid[11]") }}({{ InitData.currency }})
              </template>
              <template #text>
              <span style="color: var(--theme-color);">{{ UserInfo.today_spread || "0" }}</span>
              </template>
            </van-grid-item>
            <van-grid-item style="margin-top:5px;">
              <template #icon>
                {{ $t("user.myEarnings.grid[10]") }}({{ InitData.currency }})
              </template>
              <template #text>
                <span style="color: var(--theme-color);">{{ UserInfo.today_rebate || "0" }}</span>
              </template>
            </van-grid-item>
            <van-grid-item style="margin-top:5px;">
              <template #icon>
              {{ $t("user.myEarnings.grid[6]") }}({{ InitData.currency }})
              </template>
              <template #text>
              <span style="color: var(--theme-color);">{{ UserInfo.total_profit || "0" }}</span>
              </template>
            </van-grid-item>
          </van-grid>
        </div>
          
         <img :src=InitData.setting.invite_img  style="width:100%;padding:10px;padding-top: 130px;" @click="toPromote()"> 
		 <!-- <router-link to="/vip" class="invite_box">
		   <div class="vip-card" 
		        :style="{
		          backgroundImage: `url(./static/images/Group@2x.png)`,
		          backgroundSize: '98% 98%',
		          backgroundPosition: 'center',
		          backgroundRepeat: 'no-repeat'
		        }">
		     <span style="color: #08712A; 
		                 font-size: 1.375rem;
		                 display: flex;
		                 align-items: center;  /* 仅垂直居中 */
		                 height: 100%;">
		       {{$t("details[8]")}}
		     </span>
		   </div>
		 </router-link> -->
          <van-grid direction="vertical" :gutter="10" :column-num="4" :border="false" class="Menu">
            <van-grid-item to="/user/info" style="width: 80px;">
              <template #icon>
                <img :src="`./static/images/mine/mine_rwjl@2x.png`" style="height: 3.5rem; width: 3.5rem;" />
              </template>
              <template #text>
                <span style="color:#333333;overflow:hidden;">{{ $t("user.menu[3]") }}</span>
              </template>
            </van-grid-item>
            <van-grid-item to="/user/teamReport" style="width: 80px;">
              <template #icon>
                <img :src="`./static/images/mine/mine_td@2x.png`" style="height: 3.5rem; width: 3.5rem;" />
              </template>
              <template #text>
                <span style="color:#333333;overflow:hidden;">{{ $t("user.menu[8]") }}</span>
              </template>
            </van-grid-item>
            <van-grid-item to="/user/dayReport" style="width: 80px;">
              <template #icon>
                <img :src="`./static/images/mine/mine_mrjd@2x.png`" style="height: 3.5rem; width: 3.5rem;" />
              </template>
              <template #text>
                <span style="color:#333333;overflow:hidden;">{{ $t("user.menu[5]") }}</span>
              </template>
            </van-grid-item>
             <van-grid-item to="/user/fundRecord" style="width: 80px;">
              <template #icon>
                <img :src="`./static/images/mine/mine_cwjl@2x.png`" style="height: 3.5rem; width: 3.5rem;" />
              </template>
              <template #text>
                <span style="color:#333333;overflow:hidden;">{{ $t("user.menu[6]") }}</span>
              </template>
            </van-grid-item>
            <van-grid-item to="/help" style="width: 80px;">
              <template #icon>
                <img :src="`./static/images/mine/mine_bzzx@2x.png`" style="height: 3.5rem; width: 3.5rem;" />
              </template>
              <template #text>
                <span style="color:#333333;overflow:hidden;">{{ $t("user.menu[9]") }}</span>
              </template>
            </van-grid-item>
            <van-grid-item to="/user/credit" style="width: 80px;">
              <template #icon>
                <img :src="`./static/images/mine/mine_dkzx@2x.png`" style="height: 3.5rem; width: 3.5rem;" />
              </template>
              <template #text>
                <span style="color:#333333;overflow:hidden;">{{ $t("user.menu[10]") }}</span>
              </template>
            </van-grid-item>
            <van-grid-item @click="goDown" style="width: 80px;" >
              <template #icon>
                <img :src="`./static/images/mine/center_013.png`" style="height: 3.5rem; width: 3.5rem;" />
              </template>
              <template #text>
                <span style="color:#333333;overflow:hidden;">{{ $t("user.menu[11]") }}</span>
              </template>
            </van-grid-item>
             <!-- <van-grid-item to="/user/follow" style="width: 80px;">
              <template #icon>
                <img :src="`./static/images/mine/gz.png`" style="height: 3.5rem; width: 3.5rem;" />
              </template>
              <template #text>
                <span style="color:#333333;overflow:hidden;">{{ $t("home.qywh") }}</span>
              </template>
            </van-grid-item> -->
          </van-grid>
        <div style="height: 30px;">
        </div>

    </div>
    <Footer v-if="$route.name == 'user'" />
  </div>
</template>

<script>
export default {
  name: "User",
  components: {},
  props: [],
  data() {
    return {
      yebMoney: 0,
    };
  },
  computed: {
    cardList() {
      let data = this.$store.state.BankCardList.flatMap(item => item.bank_name + ' ' + item.card_no.replace(/^(.{4}).*(.{4})$/, '$1 **** $2'))
      // if(this.UserInfo.alipay){
      //   data.unshift(this.$t('wallet.default[7]')+this.UserInfo.alipay.replace(/^(.{4}).*(.{4})$/, '$1 **** $2'))
      // }
      return data;
    },
  },
  watch: {},
  created() {
    this.$Model.GetUserInfo();
    let obj = {
      userid: JSON.parse(localStorage.getItem("UserInfo")).userid,
    };
    this.$Model.yeb(obj, (data) => {
      this.yebMoney = data.data;
    });
  },
  mounted() { },
  activated() { },
  destroyed() { },
  methods: {
    toPromote(){
      this.$router.push("/promote");
    },
    openKefu(url) {
      window.location.href = url;
    },
    goDown() {
      const u = navigator.userAgent;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isiOS) {
        this.$Util.OpenUrl(this.InitData.setting.ios_url);
      } else {
        this.$Util.OpenUrl(this.InitData.setting.h_server_name);
      }
    },
    toRecharge() {
      this.$router.push(`/user/recharge`);
    },
    toWithdraw() {
      if (this.UserInfo.is_fund_password != 1) {
        this.$Dialog.Alert(this.$t('wallet.msg[0]'), () => {
          this.$router.push('/user/info/fpwd')
        })
      } else {
        if (this.cardList.length) {
          this.$router.push(`/user/withdraw`);
        } else {
          this.$Dialog.Alert(this.$t('wallet.msg[1]'), () => {
            this.$router.push('/user/bankCard')
          })
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
/* 头部区域：最小高度，长职称时可增高，避免 VIP 被下方白卡遮挡 */
.user-header-bg {
  min-height: 300px;
}

/* 职位列：左对齐，职位名称超过 16 字自动换行 */
.useridentity-col {
  width: 47.5%;
  padding: 22px 12px 24px 18px;
  text-align: left;
  overflow: visible;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

/* 用户 ID：加底、更鲜艳突出 */
.idcode-wrap {
  display: inline-block;
  font-weight: bold;
  color: #fff;
  background: rgba(0, 0, 0, 0.35);
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 14px;
  margin-top: 4px;
  letter-spacing: 0.5px;
}

/* 职位名称：更突出（加粗、阴影、微底） */
.useridentity-text {
  font-size: 17px;
  font-weight: 600;
  color: #fff;
  white-space: normal;
  word-break: break-word;
  text-align: left;
  max-width: 16ch;
  min-width: 0;
  line-height: 1.4;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.35);
  background: rgba(0, 0, 0, 0.2);
  padding: 6px 10px;
  border-radius: 8px;
  display: inline-block;
}

/* VIP 等级：固定一行，不被挤压、不被遮挡 */
.useridentity-vipl {
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  white-space: nowrap;
  flex-shrink: 0;
}

.MyEa_box {
  background-color: #fff;
  margin-top: 20px;
}

.login_cloud {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  height: 11.75rem;
}

.my_money {
  color: #fff;
  display: flex;
  height: 20px;
  position: relative;
}

.my_money ::v-deep .van-button {
  position: absolute;
  right: 1rem;
  font-size: 1.3rem;
  bottom: 0;
  top: 7.36rem;
  background-color: transparent;
  border: none;
}
::v-deep .van-grid-item__content {border: none;}


.UserInfo .info {
  background-color: transparent;
  position: relative;
  z-index: 3;
  height: 100px;
}

::v-deep .UserInfo .info .head .van-image__img{
  height: 70px;
  width: 70px;
  object-fit: cover;
  border-radius: 50%;
  margin-right: 10px;
}

.UserInfo .info .van-cell__title {
  font-size: 16px;
}

.UserInfo .info .van-cell__label {
  font-size: 14px;
  color: #fff;
}

.IndexBox ::v-deep .Menu {
  border: none;
}

.IndexBox ::v-deep .Menu .van-grid-item__content {
  background-color: transparent;
}

.IndexBox ::v-deep .Menu .van-grid-item {
  display: block;
  width: 100%;
}

.IndexBox {
  background-color: #fafafa;
}

.UserInfo .info .van-cell__value {
  flex: none;
  line-height: 1.3;
}

.UserInfo .info .van-cell__value a {
  text-align: center;
  color: #fff;
  display: block;
}

.UserInfo .money {
  padding: 0 16px;
  position: relative;
  z-index: 2;
  width: 100%;
}

.username {
  font-size: 1.13rem;
  font-weight: bold;
  margin-top: 10px;
  color:#fff;
}

.UserInfo .money::before {
  content: "";
  display: block;
  background-color: transparent;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: -50%;
}

.my_ye_number {
  padding-left: 20px;
  color: #4F8FF7;
  font-weight: bold;
  font-size: 1.6rem;
}

.van-cell {
  padding: 0;
}

.user_head {
  height: 16.75rem;
}

.my_ye_text {
  padding-left: 20px;
  color: #fff;
  font-size: 1.01rem;
}

.UserInfo .money>div {
  border-radius: 5px;
  background-color: #fff;
  box-shadow: 0 2px 5px #888;
  overflow: hidden;
  width: 100%;
  position: relative;
  z-index: 2;
  padding: 0 5px;
}

.UserInfo .money .van-steps {
  padding: 8px 16px 0;
}

.UserInfo .money .van-steps ::v-deep .van-step__title {
  font-size: 14px;
}

.UserInfo .money .van-cell {
  background-color: #fff;
}

.UserInfo .money .van-cell__title em {
  font-size: 22px;
  color: #4087f1;
}

// .Menu {
//   border-top: 10px #0e1526 solid;
//   margin-bottom: 15px;
// }

// .Menu ::v-deep .van-grid-item__text {
//   font-size: 15px;
//   color: #333;
//   text-align: center;
// }

// .Menu ::v-deep .van-grid-item__content {
//   background-color: #151d31;
// }

.MyEa_box ::v-deep .van-grid-item__content {
  box-shadow: none;
}

.r_link {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 14px 16px;
}

.r_link .left {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

.r_link .left img {
  width: 1.5rem;
  height: 1.5rem;
  margin-right: 8px;

}

.r_link .van-icon {
  font-weight: bold;
}

.van-icon__image {
  width: 70px;
  height: 100%;
}
::v-deep .van-cell{
  padding: 5px 0;
}
.Menu {
    margin: 10px 0;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 20px;
    margin-left: 10px;
    margin-right: 10px;
}


.vip-card {
  height: 85px;
  display: flex;                /* 启用flex布局 */
  // justify-content: center;      /* 水平居中 */
  align-items: center;          /* 垂直居中 */
  position: relative;
  margin: 15px 10px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  
  /* 添加渐变遮罩提升可读性 */
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(245,245,245,0.2) 100%);
  }
  
  span {
    position: relative; /* 确保文字在遮罩层之上 */
    z-index: 1;
	padding-left: 5px;
    text-shadow: 0 2px 4px rgba(0,0,0,0.2); /* 添加文字阴影 */
  }
}
</style>